import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

function AdminContactMessages() {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { token } = useAuth();

    useEffect(() => {
        const fetchMessages = async () => {
            try {
                const response = await fetch('https://healthcard.searchisend.com/health_api/get_contact_messages.php', {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch messages');
                }
                const data = await response.json();
                setMessages(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchMessages();
    }, [token]);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString();
    };

    if (loading) return <div className="p-8 text-center text-slate-500 font-medium">Loading messages...</div>;
    if (error) return <div className="p-8 text-center text-red-500 font-medium">Error: {error}</div>;

    return (
        <div className="p-8 max-w-6xl mx-auto">
            <h1 className="text-3xl font-extrabold text-brand-secondary mb-8">Contact Form Messages</h1>

            {messages.length === 0 ? (
                <div className="bg-white p-12 rounded-3xl shadow-sm border border-slate-200 text-center">
                    <div className="w-16 h-16 bg-slate-100 text-slate-400 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                    </div>
                    <h2 className="text-xl font-bold text-slate-700">No Messages Yet</h2>
                    <p className="text-slate-500">When users submit contact forms, they will appear here.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {messages.map((msg) => (
                        <div key={msg.id} className="bg-white rounded-3xl p-6 shadow-md border border-slate-200 flex flex-col">
                            <div className="flex justify-between items-start mb-4">
                                <div>
                                    <h3 className="font-bold text-lg text-brand-secondary line-clamp-1" title={msg.name}>{msg.name}</h3>
                                    <a href={`mailto:${msg.email}`} className="text-brand-primary hover:underline text-sm font-medium line-clamp-1" title={msg.email}>{msg.email}</a>
                                </div>
                            </div>
                            <div className="bg-slate-50 rounded-xl p-4 flex-grow mb-4">
                                <p className="text-slate-700 whitespace-pre-wrap text-sm">{msg.message}</p>
                            </div>
                            <div className="text-xs text-slate-400 font-medium mt-auto flex items-center gap-1 border-t border-slate-100 pt-3">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                {formatDate(msg.createdAt)}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default AdminContactMessages;
